
export enum ERegion {
  ES = 'ES',
  PT = 'PT'
}

export const REGIONS = Object.values(ERegion);

export type UniRegionalizationConfig = {
  grade: { min: number; max: number };
};

export type RegionalizationConfig = {
  uni: Record<ERegion, UniRegionalizationConfig>;
};

export const REGIONALIZATION: RegionalizationConfig = {
  uni: {
    [ERegion.ES]: { grade: { min: 1, max: 10 } },
    [ERegion.PT]: { grade: { min: 1, max: 20 } }
  }
};